import { Box, Text, VStack, Badge, Flex } from '@chakra-ui/react';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface ExceptionalUsageCardProps {
  data?: any;
}

const ExceptionalUsageCard = ({ data }: ExceptionalUsageCardProps) => {
  const colors = useBinderCardColors();

  // Get processed data
  const exceptionalUsageStatus = data?.hasExceptionalUsage || false;

  const formatExceptionalUsageStatus = (hasUsage: boolean) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {hasUsage ? 'Yes' : 'No'}
      </Badge>
    );
  };

  return (
    <Box>
      {/* Header */}
      <VStack align="start" spacing={3} mb={6}>
        <Text fontSize="sm" color={colors.descriptionColor} lineHeight="1.5">
          Will any of the described automobiles be rented or leased to others,
          or used to carry passengers for compensation or hire, or haul a
          trailer, or carry explosives or radioactive material?
        </Text>
      </VStack>

      {/* Content */}
      <Box
        borderRadius="md"
        borderWidth="1px"
        borderColor={colors.borderColor}
        p={4}
      >
        <VStack align="stretch" spacing={4}>
          {/* Status Field */}
          <Flex justify="end" align="center">
            {formatExceptionalUsageStatus(exceptionalUsageStatus)}
          </Flex>

          {/* Remarks Field */}
          {data.remarks ? (
            <Box>
              <Text
                fontSize="sm"
                color={colors.labelColor}
                fontWeight="medium"
                mb={2}
              >
                Exceptional Usage Details
              </Text>
              <VStack align="stretch" spacing={2}>
                {data.remarks && (
                  <Text as="span" fontWeight="medium">
                    {data.remarks}
                  </Text>
                )}
              </VStack>
            </Box>
          ) : (
            <Text color="gray.400" fontStyle="italic" fontSize="sm">
              No exceptional usage remarks
            </Text>
          )}
        </VStack>
      </Box>
    </Box>
  );
};

export default ExceptionalUsageCard;
